
// Email validation using a more comprehensive regex
export const isValidEmail = (email: string): boolean => {
  if (!email) return false;
  
  // RFC 5322 compliant regex
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(email);
};

// Password strength validation
export const isStrongPassword = (password: string): boolean => {
  if (!password || password.length < 8) return false;
  
  // Must contain at least one lowercase letter, one uppercase letter, one digit and one special character
  const hasLowercase = /[a-z]/.test(password);
  const hasUppercase = /[A-Z]/.test(password);
  const hasDigit = /\d/.test(password);
  const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);
  
  return hasLowercase && hasUppercase && hasDigit && hasSpecialChar;
};

// Phone number validation (simple format check)
export const isValidPhoneNumber = (phone: string): boolean => {
  if (!phone) return false;
  
  // Basic phone validation (should be enhanced for international numbers)
  const phoneRegex = /^\+?[\d\s\(\)-]{10,20}$/;
  return phoneRegex.test(phone);
};

// Validate IP address
export const isValidIPAddress = (ip: string): boolean => {
  if (!ip) return false;
  
  // IPv4 validation
  const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  
  // IPv6 validation (simplified)
  const ipv6Regex = /^(?:[A-F0-9]{1,4}:){7}[A-F0-9]{1,4}$/i;
  
  return ipv4Regex.test(ip) || ipv6Regex.test(ip);
};
